import React from 'react'
import {getTaskTypeIconParser} from '../../shared/enums/task-type-icon-parser'

export default React.createClass({

  render: function () {
    let show =[];
    let icon;
    let imgsrc;
    if(this.props.icon){
      if(this.props.data.length > 1){
        for(let i = 0; i < this.props.data.length; i++){
          icon = (getTaskTypeIconParser(this.props.data[i].data.taskType))
          imgsrc = icon.iconsrc
          show.push(
            <div key={'hello' + i} style={{width: '50%', float: 'left', textAlign: 'center'}}>
              <div role="presentation" key={i} className={`clickable ${imgsrc}-circle`} onClick={() => this.props.show(this.props.data[i].data)} style={{width: 30, height: 30, position: 'relative', top: -5}} />
            </div>
            );
        }
      }
      else if(this.props.data.length === 1){
          icon = (getTaskTypeIconParser(this.props.data[0].data.taskType))
          imgsrc = icon.iconsrc
          show.push(<div role="presentation" key={0} className={`clickable img-responsive center-block ${imgsrc}-circle`} onClick={() => this.props.show(this.props.data[0].data)} style={{width: 40, height: 40}}/>)
      }
    }else{
      show.push(
        <div key='w' className='clickable' style={{margin: 'auto',color: 'white', width: 26, height: 26, background: '#78A12E', borderRadius: '100%'}}></div>
      );
    }
    
    return (
      <div style={{textAlign: 'center', width: '70%', margin: 'auto'}} className={'task-type center small no-text'}>
        {show}
      </div>
    )
  }
})




// WEBPACK FOOTER //
// ./src/components/schedule/calendar-icon/calendar-icon.jsx